<div class="myModal">
  <div class="modal-header">
    <button (click)="exitModal()" class="close"  aria-label="close">
      <mat-icon aria-hidden="true">close</mat-icon>
    </button>
  </div>
  <div class="modal-body">
    <p style="white-space: pre-line">{{ preferenceMessages.modal_diffuseur_content | translate }}</p>
    <form class="form" [formGroup]="form">
      <app-form-input [parentForm]="form" [label]="preferenceMessages.modal_diffuseur_intitule | translate" [type]="'text'"
      [rule]="'required'" [name]="'intitule'"></app-form-input>
    </form>
  </div>
  <div class="modal-footer">
    <button aria-label="confirmer"[disabled]="(!form.valid)" (click)="valider()" class="btn btn-primary" 
      >{{ preferenceMessages.modal_diffuseur_confirmer | translate }}</button>
    <button aria-label="retour" (click)="exitModal()" class="btn btn-outline-primary" 
      >{{ preferenceMessages.modal_diffuseur_retour | translate }}</button>
  </div>
</div>
